export type VerticalDropPosition = 'above' | 'below'

export interface VerticalDropTarget {
  targetId: string
  position: VerticalDropPosition
}

export interface VerticalDropCandidate {
  targetId: string
  rect: Pick<DOMRect, 'top' | 'bottom' | 'height'>
}

export function resolveVerticalDropTarget(params: {
  activeId: string
  pointerY: number
  candidates: VerticalDropCandidate[]
}): VerticalDropTarget | null {
  const { activeId, pointerY, candidates } = params

  const eligibleCandidates = candidates.filter(
    candidate => candidate.targetId !== activeId,
  )

  if (eligibleCandidates.length === 0) {
    return null
  }

  const containingCandidate = eligibleCandidates.find(
    ({ rect }) => pointerY >= rect.top && pointerY <= rect.bottom,
  )

  const nearestCandidate =
    containingCandidate ||
    eligibleCandidates.reduce((closest, current) => {
      const currentDistance =
        pointerY < current.rect.top
          ? current.rect.top - pointerY
          : pointerY > current.rect.bottom
            ? pointerY - current.rect.bottom
            : 0
      const closestDistance =
        pointerY < closest.rect.top
          ? closest.rect.top - pointerY
          : pointerY > closest.rect.bottom
            ? pointerY - closest.rect.bottom
            : 0

      return currentDistance < closestDistance ? current : closest
    })

  if (!nearestCandidate) {
    return null
  }

  const midpoint = nearestCandidate.rect.top + nearestCandidate.rect.height / 2

  return {
    targetId: nearestCandidate.targetId,
    position: pointerY < midpoint ? 'above' : 'below',
  }
}
